import Chart from "react-apexcharts";
import formatarDuracao from "../../utils/formatarDuracao";

function BarChart({ title, data, suffix, formatter, metric }) {
  const yData = data.data;
  const categories = data.days;
  const normalizedSuffix = suffix || "";

  const formatMetricValue = (value) => {
    if (formatter === "duration") return formatarDuracao(value);
    const numericValue = Number(value || 0);
    if (normalizedSuffix.includes("%")) {
      return `${numericValue.toLocaleString("pt-BR", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      })}${normalizedSuffix}`;
    }

    return `${numericValue.toLocaleString("pt-BR", {
      maximumFractionDigits: 2,
    })}${normalizedSuffix}`;
  };

  const options = {
    chart: {
      height: 350,
      type: "bar",
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        dataLabels: {
          position: "top", // top, center, bottom
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return formatMetricValue(val);
      },
      offsetY: -20,
      style: {
        fontSize: "12px",
        colors: ["#304758"],
      },
    },
    tooltip: {
      enabled: true,
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {
        const value = series[seriesIndex][dataPointIndex];
        const category = w.globals.labels[dataPointIndex];
        const metricLabel = metric || "Valor";
        return `
          <div style="padding: 10px; background: #fff; border: 1px solid #ccc; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
            <div style="font-weight: bold; margin-bottom: 4px;">${category}</div>
            <div style="color: #666;">${metricLabel}: ${formatMetricValue(value)}</div>
          </div>
        `;
      },
    },

    xaxis: {
      categories: categories,
      position: "bottom",
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      crosshairs: {
        fill: {
          type: "gradient",
          gradient: {
            colorFrom: "#D8E3F0",
            colorTo: "#BED1E6",
            stops: [0, 100],
            opacityFrom: 0.4,
            opacityTo: 0.5,
          },
        },
      },
      tooltip: {
        enabled: true,
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: function (val) {
          return formatMetricValue(val);
        },
      },
    },
    ...(title
      ? {
          title: {
            text: title,
            align: "center",
          },
        }
      : {}),
  };

  const series = [
    {
      name: metric,
      data: yData,
    },
  ];

  return <Chart options={options} series={series} type="bar" height={350} />;
}

export default BarChart;
